"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultShadows = void 0;
var tokens_1 = require("@prezzee/tokens");
exports.defaultShadows = {
    xs: tokens_1.shadows.xs,
    sm: tokens_1.shadows.sm,
    md: tokens_1.shadows.md,
    lg: tokens_1.shadows.lg,
    xl: tokens_1.shadows.xl,
};
//# sourceMappingURL=shadows.js.map